import React, { useEffect, useState, useCallback } from "react";
import LayoutV2 from "containers/LayoutV2";
import SearchForm from "./SearchForm";
import PhanTrang from "components/CommonComponent/PhanTrang";
import LoiNhuanBanHangTable from "./LoiNhuanBanHangTable";
import UserApi from "service/userApi";
import LoiNhuanBanHangApi from "service/QuanLyMuaBan/LoiNhuanBanHangApi"; 
import { formatDayMonth } from "utils/formatDate";
import { pushNotification } from "utils/notifications";
import { cloneDeep } from "lodash"; 

const DanhSachLoiNhuanBanHang = () => {
    const [hasPermission, setHasPermission] = useState(null);
    const [RoleDanhSach, setRoleDanhSach] = useState(false);
    const [RoleIn, setRoleIn] = useState(false);
    const [ListData, setListData] = useState([]);
    const [Total, setTotal] = useState(0);
    const [Loading, setLoading] = useState(true);
    const [TotalSoTienMua, setTotalSoTienMua] = useState(0);
    const [TotalPhiSanXuat, setTotalPhiSanXuat] = useState(0);
    const [TotalSoTienBan, setTotalSoTienBan] = useState(0);
    const [TotalLoiNhuan, setTotalLoiNhuan] = useState(0);

    const [dataSearch, setDataSearch] = useState({
        SearchText: "",
        SoSanh: "", 
        LoiNhuanSS: 0,
        DateFrom: null,
        DateTo: null,
        pageIndex: 1,
        pageSize: 25
    });

    const fetchPermission = () => {
        setLoading(true); 
        try {
            UserApi.getAllQuyen()
                .then((res) => {
                    const detailedRoles = res.data.map((item) => item.ModuleCode.toLowerCase());
                    const hasPageAccess = detailedRoles.includes("loinhuanbanhang");
                    setHasPermission(hasPageAccess);
                    if (hasPageAccess) {
                        setRoleDanhSach(detailedRoles.includes("loinhuanbanhang_danhsach"));
                        setRoleIn(detailedRoles.includes("loinhuanbanhang_indanhsach"));
                    }
                })
                .catch((err) => setHasPermission(false));
        } catch (err) {
            setHasPermission(false);
        } 
    };

    const LoadDanhSach = useCallback((searchData, page) => {
        setLoading(true);
        const payload = {
            ...searchData,
            DateFrom: searchData.DateFrom ? formatDayMonth(searchData.DateFrom) : "", 
            DateTo: searchData.DateTo ? formatDayMonth(searchData.DateTo) : "", 
            pageIndex: page,
            LoiNhuanSS: searchData.LoiNhuanSS || 0
        };
        LoiNhuanBanHangApi.getData(payload)
            .then((res) => {
                if (res.status === 200) {
                    const data = res.data || {};
                    setListData(data.List || []);
                    setTotal(data.TotalRecords || 0);
                    setTotalSoTienMua(data.TotalSoTienMua || 0);
                    setTotalPhiSanXuat(data.TotalPhiSanXuat || 0);
                    setTotalSoTienBan(data.TotalSoTienBan || 0);
                    setTotalLoiNhuan(data.TotalLoiNhuan || 0);
                    setDataSearch((prev) => ({ ...prev, pageIndex: page }));
                } else {
                    pushNotification("Load danh sách thất bại!", "error");
                }
            })
            .catch((error) => pushNotification("Có lỗi khi gọi Api!", "error"))
            .finally(() => {
                setLoading(false);
            });
    }, []);

    useEffect(() => {
        document.title = "Lợi nhuận bán hàng | Phần mềm quản lý cầm đồ Morman";
        fetchPermission();
    }, []); 

    useEffect(() => {
        if (hasPermission) {
            LoadDanhSach(dataSearch, 1);
        }
    }, [hasPermission]); 

    const onChangeData = (field) => (event) => { 
         const value = event?.target?.value ?? (event?.value ?? ""); 
         setDataSearch((prev) => ({ ...prev, [field]: value }));
    };
    const onChangeDate = (field) => (value) => { 
         setDataSearch((prev) => ({ ...prev, [field]: value }));
    };
    const handlePageChange = (pageNumber) => {
        LoadDanhSach(dataSearch, pageNumber);
    };
    const handlePageSizeChange = (pageSize) => {
        const data = { ...dataSearch, pageSize, pageIndex: 1 };
        setDataSearch(data);
        LoadDanhSach(data, 1);
    };
    const onSearch = () => { 
        LoadDanhSach(dataSearch, 1);
    };
    const handleKeyDown = (event) => { 
        if (event.key === "Enter") {
            event.preventDefault();
            LoadDanhSach(dataSearch, 1);
        }
    };

    const handleUpdateDaXem = (orderID, taiSanID) => {
        setListData(prevList => {
             const newList = cloneDeep(prevList);
             const item = newList.find(i => i.OrderID === orderID && i.TaiSanID === taiSanID);
             if (item) item.IsReaded = !item.IsReaded;
             return newList;
        });
        LoiNhuanBanHangApi.updateDaXem(orderID, taiSanID)
            .catch((err) => {
                pushNotification("Cập nhật thất bại", "error");
                setListData(prevList => {
                    const newList = cloneDeep(prevList);
                    const item = newList.find(i => i.OrderID === orderID && i.TaiSanID === taiSanID);
                    if (item) item.IsReaded = !item.IsReaded;
                    return newList;
                });
            });
    };

    if (hasPermission === false) {
        return (
            <LayoutV2>
                <h2 className="text-danger text-center mt-5">Bạn không có quyền truy cập trang này! (loinhuanbanhang)</h2>
            </LayoutV2>
        );
    }
    return (
        <>
            <LayoutV2>
                <div id="form-repeater">
                    <div className="sticky-moman-bh">
                        <div className="col-12">
                            <div className="camdo-home">
                                <div className="breadcrumb-new">
                                    <div className="row">
                                        <div className="col-sm-12 col-md-12 title-cd">
                                            <div className="media-home align-center-home">
                                                <div className="row header">
                                                    <img src="/app-assets/images/logo-quan-ly-mua-ban-nhap-hang-v2.png" alt="logo" />
                                                    <h1 className="text-info-home" style={{fontSize:25}}>Quản lý mua bán - Lợi nhuận bán hàng</h1>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="card border-light mb-1 show-table-main card-v2">
                                    <div className="card-body card-body-v2">
                                        <SearchForm
                                            dataSearch={dataSearch}
                                            onChangeData={onChangeData}
                                            onChangeDate={onChangeDate}
                                            onSearch={onSearch}
                                            handleKeyDown={handleKeyDown}
                                            RoleIn={RoleIn} 
                                        />
                                    </div>
                                </div>
                                {Loading && (<div className="loader loader-default is-active"></div>)}
                                {!Loading && RoleDanhSach && (<>
                                    <div className="card border-light mb-1 card-v2" style={{ marginTop: "0px" }}>
                                        <div className="card-body card-body-v2" style={{ userSelect: "text" }}>
                                            <LoiNhuanBanHangTable
                                                list={ListData}
                                                TotalSoTienMua={TotalSoTienMua}
                                                TotalPhiSanXuat={TotalPhiSanXuat}
                                                TotalSoTienBan={TotalSoTienBan}
                                                TotalLoiNhuan={TotalLoiNhuan}
                                                Total = {Total}
                                                onUpdateDaXem={handleUpdateDaXem}
                                            />
                                        </div>
                                        <div className="card border-light mb-1 card-v2" style={{ marginLeft: "15px", marginRight: "15px", marginTop: "15px" }}>
                                            <div className="card-body card-body-v2" style={{ display: Total === 0 ? "none" : "block" }}>
                                                <PhanTrang
                                                    pageIndex={dataSearch.pageIndex}
                                                    pageSize={dataSearch.pageSize}
                                                    totalCount={Total}
                                                    onPageChange={handlePageChange}
                                                    onPageSizeChange={handlePageSizeChange}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </>)}
                                {!Loading && !RoleDanhSach && hasPermission && (
                                    <h4 className="text-danger text-center mt-3">Bạn không có quyền xem danh sách lợi nhuận.</h4>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </LayoutV2>
        </>
    )
}
export default DanhSachLoiNhuanBanHang;